import { render, staticRenderFns } from "./navbar-workspaces-menu.vue?vue&type=template&id=660fe9f0&scoped=true&"
import script from "./navbar-workspaces-menu.vue?vue&type=script&lang=ts&"
export * from "./navbar-workspaces-menu.vue?vue&type=script&lang=ts&"
import style0 from "./navbar-workspaces-menu.vue?vue&type=style&index=0&id=660fe9f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660fe9f0",
  null
  
)

export default component.exports